import { Component, SimpleChanges, Input } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'TeilnehmerInfo',
  templateUrl: 'TeilnehmerInfo.html'
})
export class TeilnehmerInfoComponent {

	@Input()
	teilnehmerOrt : string = "";
	@Input()
	teilnehmerBezeichnung : string = "";

	bezeichnung : SafeHtml = ""; // Das wird dargestellt.
	ort : SafeHtml | undefined = undefined; // Das wird dargestellt.


	/**	=== Visionet(sl) ==========
	 *	Beim Aufruf des Konstruktors ist der Eingangs-Parameter `teilnehmerInfo` noch undefiniert.
	 *	Wir brauchen den Konstruktor nur um den `DomSanitizer` zu erhalten.
	 */
	constructor(public sanitizer: DomSanitizer) {
	}


	/**	=== Visionet(sl) ==========
	 *	Bei jeder Änderung des Eingangs-Parameters `teilnehmerInfo`  in der übergeordneten Seite wird
	 *	die Funktion `ngOnChanges`  aufgerufen und enthält im Parameter `changes` den geänderten Wert.
	 *	Dieser Wert ist aber ein ungültiges HTML weil dort das Attribut `checklisteId` im <a>-Tag vorkommt.
	 *	In diesem Attribut steht die ID der Ziel-Checkliste.
	 *	Wir müssen dem Programm beibringen, dass das schon in Ordnung ist und erklären, dass es sich um
	 *	sicheres HTML (`SafeHtml`) handelt.
	 *	Sicheres HTML aus einem String macht man per `DomSanitizer`
	 *	Das alleine reicht aber noch nicht. Das <a>-Tag verweist ja nicht direkt per href-Attribut auf eine Zielseite.
	 *	Der Klick auf muss abgefangen werden und per `NavController` zur Ziel-Checklsite navigiert werden.
	 *	Dazu (siehe HTML) wird im <div>-Tag über das Attribut `cklickHandler` eine `@Directive` verankert.
	 *	Die `@Directive` registreiert dann `cklickHandler` als Selektor und überall wo der auftaucht
	 *	schlägt die Direktive dan zu.
	 */
	ngOnChanges(changes: SimpleChanges) : void {
		this.bezeichnung = this.sanitizer.bypassSecurityTrustHtml(changes.teilnehmerBezeichnung.currentValue.replace(/\r\n/g, "<br/>") );
		if (this.teilnehmerOrt) {
			this.ort = this.sanitizer.bypassSecurityTrustHtml(changes.teilnehmerOrt.currentValue.replace(/\r\n/g, "<br/>") );
		}
	}

}



// WEBPACK FOOTER //
// ./src/components/TeilnehmerInfo/TeilnehmerInfo.ts